module.exports = __webpack_public_path__ + "static/media/Post box 3.8e49407b.jpg";